export const TURTL_HOST_NAME = 'square.turtl.co';
